// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"SheetCard_tagsWrapper__x8PVe"};